import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { Breadcrumb, I18nModule } from '@spartacus/core';
import { ActiveFacetsComponent, KeyboardFocusModule } from '@spartacus/storefront';

import { DpActiveFacetsHeightMonitorDirective } from './active-facets-height-monitor.directive';

import { MATERIAL_APPLICATION_CODE } from '../../shared/constants';

@Component({
    selector: 'dp-active-facets',
    templateUrl: './active-facets.component.html',
    styleUrl: './active-facets.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [
        {
            directive: DpActiveFacetsHeightMonitorDirective,
            inputs: ['maxHeight', 'activeFacets'],
            outputs: ['heightChanged']
        }
    ],
    imports: [RouterModule, I18nModule, KeyboardFocusModule, AsyncPipe, MatIcon, NgClass]
})
export class DpActiveFacetsComponent extends ActiveFacetsComponent {
  activeFacets = input.required<Breadcrumb[]>();

  readonly MATERIAL_APPLICATION_CODE = MATERIAL_APPLICATION_CODE;
}
